import Localization from 'modules/Localization';
import { ExitAllButtonProps } from 'modules/TradingChart/components/TradingView/components/UpdatePositionPnl/typings';

export const createExitAllButton = (
  { isDisabled, onClick }: ExitAllButtonProps,
): DocumentFragment => {
  const exitAllButtonContainer = document.createDocumentFragment();

  const exitAllButton = document.createElement('button');
  exitAllButton.textContent = Localization.translate('POSITIONS_MTM_EXIT_ALL_BUTTON');
  exitAllButton.setAttribute('style', `
    margin-left: 12px;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    font-size: 14px;
    color: var(--tv-color-item-active-text);
    line-height: normal;
    display: flex;
    border: none;
    background: ${isDisabled
      ? 'var(--tv-color-toolbar-button-background-disabled)'
      : 'var(--tv-color-toolbar-button-sell-active)'};
    cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
  `);

  if (!isDisabled) {
    exitAllButton.addEventListener('click', onClick);
  }

  const separator = document.createElement('span');
  separator.setAttribute('style', `
    color: var(--tv-color-toolbar-divider-background);
    margin-left: 10px;
    margin-top: -4px;
    font-size: 26px;
    font-weight: 10;
  `);
  separator.textContent = '|';

  exitAllButtonContainer.appendChild(exitAllButton);
  exitAllButtonContainer.appendChild(separator);

  return exitAllButtonContainer;
};

export const createPnLElement = (totalPnL: string): DocumentFragment => {
  const pnlContainer = document.createDocumentFragment();

  const container = document.createElement('div');
  container.className = 'pnl-container';
  container.setAttribute('style', `
    display: flex;
    align-items: center;
  `);

  const separator = document.createElement('span');
  separator.textContent = '|';
  separator.setAttribute('style', `
    color: var(--tv-color-toolbar-divider-background);
    margin-right: 8px;
    margin-top: -4px;
    font-size: 26px;
    font-weight: 10;
  `);

  const mtmLabel = document.createElement('span');
  mtmLabel.textContent = 'Total Positions P&L: ';
  mtmLabel.setAttribute('style', `
    color: var(--tv-color-label-primary-text);
    font-weight: 600;
    margin-right: 4px;
  `);

  const pnlValueSpan = document.createElement('span');
  pnlValueSpan.className = 'pnl-value';
  pnlValueSpan.textContent = totalPnL || '00.00';

  const cleanedPnL = totalPnL.replace('₹', '');
  const pnlValueNumber = parseFloat(cleanedPnL || '0');

  pnlValueSpan.setAttribute('style', `
    min-width: 84px;
    display: inline-block;
    color: ${getTextColor(pnlValueNumber)};
    font-weight: 600;
  `);

  container.appendChild(separator);
  container.appendChild(mtmLabel);
  container.appendChild(pnlValueSpan);
  pnlContainer.appendChild(container);

  return pnlContainer;
};

export const getTextColor = (pnlValueNumber: number): string => {
  if (pnlValueNumber > 0) {
    return 'var(--tv-color-positive-trend-text)';
  }
  if (pnlValueNumber < 0) {
    return 'var(--tv-color-negative-trend-text)';
  }
  return '';
};
